module.exports = __webpack_public_path__ + "static/media/YashB1.8f29f8ae.png";